import { memo } from 'react'
import { CreateOrderComponent } from './CreateOrder'
import { isMobile } from 'utils/userAgent'
import { MobileCreateOrder } from './MobileCreateOrder'

export const CreateOrder = memo(() => {
  if (isMobile) {
    return <MobileCreateOrder />
  }
  return <CreateOrderComponent />
})
